import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useSummaryChartsDataContext } from './hooks/useSummaryChartsDataContext';

export const AnnualEvolutionServices = () => {
    const { chartData } = useSummaryChartsDataContext();


    return (
        <SimpleBars
            title={'Evolução Anual do Total de Atendimentos'}
            horizontal={false}
            subtitles={chartData?.annualEvolutionServices?.map((item) => item.description)}
            values={chartData?.annualEvolutionServices?.map((item) => item.total  ||  0)}
        />
    );
};
